import { createMainAppMicroserviceInstance } from '@servicetitan/cp-api';
import { inject, injectable, optional } from '@servicetitan/react-ioc';
import { CustomerPortalFeatureGates, CustomerPortalFeatures } from './portal-features.api';

@injectable()
export class FeaturesApi {
    private api: CustomerPortalFeatures;

    constructor(@inject('baseUrl') @optional() baseUrl?: string) {
        this.api = new CustomerPortalFeatures(
            createMainAppMicroserviceInstance('/v1/customerportal2/features', '/api/cp/features'),
            baseUrl
        );
    }

    getFeatureGates(): Promise<CustomerPortalFeatureGates> {
        return this.api.getFeatureGates().then(({ data }) => data);
    }
}
